import { initForegroundMessaging } from "./firebaseWorker";

export async function register(): Promise<void> {
  try {
    await initForegroundMessaging();
  } catch (error) {
    console.error("[FCM] init failed:", error);
  }
}

export function unregister(): void {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        if (registration.active?.scriptURL.includes("firebase-messaging-sw.js")) {
          void registration.unregister();
        }
      });
    });
  }
}
